/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_close': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M302.056 236.369l512.889 512.888q15.084 15.085 0 30.17l-30.17 30.17q-15.085 15.085-30.17 0L241.717 296.708q-15.085-15.085 0-30.17l30.17-30.17q15.084-15.084 30.17 0z"/><path pid="1" d="M232.583 758.404l512.888-512.888q15.085-15.085 30.17 0l30.17 30.17q15.085 15.085 0 30.17L292.923 818.744q-15.085 15.085-30.17 0l-30.17-30.17q-15.085-15.085 0-30.17z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/icon_close.js